import { FolderOpen } from 'lucide-react';
import Archivos from '../archivos/Archivos';

/* =====================================================================
   Las pantallas del carril `archivos` · DIRECTRIZ-ARCHIVOS
   =====================================================================
   R-AR6, dónde cuelga: la recomendación del dueño era módulo propio, pero
   DIRECTRIZ-EXPERIENCIA fijó el menú en OCHO módulos (medido y con
   prueba); un noveno rompería esa regla. «Archivos» va en Operación —es
   donde se trabaja con los documentos— como primera opción, y si el dueño
   prefiere módulo propio es un cambio de dato en `experiencia/menu.js`
   (MAXIMO_MODULOS y ORDEN_MODULOS). La ve quien tiene `archivos.ver`
   (de fábrica, todos los roles).
   ===================================================================== */
export default {
  orden: 5,
  grupos: [{
    grupo: 'Operación',
    items: [
      { id: 'archivos', etiqueta: 'Archivos', icono: FolderOpen, min: 'CONSULTA', soloEmpresa: true, Comp: Archivos },
    ],
  }],
};
